<template>
  <div>
    <vs-card>
      <div>
        <b-row align-h="end">
          <b-col lg="2" sm="5">
            <b-form-input
              v-model="arananDeger"
              @keyup.enter="listeleTop"
              id="smallInput"
              placeholder="Arama..."
            />
          </b-col>

          <b-col lg="3" sm="5">
            <b-form-datepicker
              id="datepickerbaslangic"
              v-model="datepickerbaslangic"
              local="en"
              today-variant="danger"
              placeholder="Başlangıç Tarihi"
              :start-weekday="weekday"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              }"
            />
          </b-col>
          <b-col lg="3" sm="5">
            <b-form-datepicker
              id="datepickerbitis"
              v-model="datepickerbitis"
              placeholder="Bitiş Tarihi"
              local="en"
              today-variant="danger"
              :start-weekday="weekday"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              }"
            />
          </b-col>
          <b-col lg="2" sm="5">
            <vs-button
              style="border-radius: 5px; width: 100%"
              type="gradient"
              @click="cariKarlilik()"
              id="button-with-loading-cari"
              class="vs-con-loading__container"
              >Cari Karlılık</vs-button
            >
          </b-col>
          <b-col lg="2" sm="5">
            <vs-button
              @click="stokKarlilik()"
              color="success"
              type="gradient"
              style="border-radius: 5px; width: 100%"
              id="button-with-loading-stok"
              class="vs-con-loading__container"
              >Stok Karlılık</vs-button
            >
          </b-col>
          <b-col style="margin-top: 5px" lg="2" sm="5">
            <vs-button
              @click="stokgrupKarlilik()"
              color="danger"
              type="gradient"
              style="border-radius: 5px; width: 100%"
              id="button-with-loading-stokgrup"
              class="vs-con-loading__container"
              >Stok Grup Karlılık</vs-button
            >
          </b-col>
          <b-col style="margin-top: 5px" lg="2" sm="5">
            <vs-button
              @click="personelKarlilik()"
              color="warning"
              type="gradient"
              style="border-radius: 5px; width: 100%"
              id="button-with-loading-personel"
              class="vs-con-loading__container"
              >Personel Karlılık</vs-button
            >
          </b-col>
        </b-row>
      </div>
    </vs-card>
    <b-row style="height: 500px">
      <vs-card v-if="turKontrol">
        <div slot="header">
          <h3>{{ turDegeri }}</h3>
        </div>
        <div v-if="turDegeri == 'Personel Karlılık'">
          <ag-grid-vue
            style="width: 100%; height: 450px; margin-top: 25px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefsPersonel"
            :rowData="rowDataPersonel"
            :localeText="localeText"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </div>
        <div v-if="turDegeri == 'Stok Grup Karlılık'">
          <ag-grid-vue
            style="width: 100%; height: 450px; margin-top: 25px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefsStokgrup"
            :rowData="rowDataStokgrup"
            :localeText="localeText"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </div>
        <div v-if="turDegeri == 'Stok Karlılık'">
          <ag-grid-vue
            style="width: 100%; height: 450px; margin-top: 25px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefsStok"
            :rowData="rowDataStok"
            :localeText="localeText"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </div>
        <div v-if="turDegeri == 'Cari Karlılık'">
          <ag-grid-vue
            style="width: 100%; height: 450px; margin-top: 25px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefsCari"
            :rowData="rowDataCari"
            :localeText="localeText"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </div>
      </vs-card>
    </b-row>
  </div>
</template>
<script>
import moment from "moment";
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import CariKarlilikDetayButon from "../components/crm-components/finans-components/CariKarlilikDetayButon.vue";
export default {
  components: {
    AgGridVue,
    CariKarlilikDetayButon
  },
  data() {
    return {
      weekday: 1,
      columnDefsCari: null,
      rowDataCari: null,
      columnDefsPersonel: null,
      rowDataPersonel: null,
      columnDefsStokgrup: null,
      rowDataStokgrup: null,
      columnDefsStok: null,
      rowDataStok: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      turKontrol: false,
      turDegeri: "",
      datepickerbitis: "",
      placeholderbitis: "",
      datepickerbaslangic: "",
      placeholderbaslangic: "",
      arananDeger: "",
      localeText: null
    };
  },
  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    personelKarlilik() {
      this.turKontrol = true;
      this.turDegeri = "Personel Karlılık";
      this.listeleTop();
    },
    stokgrupKarlilik() {
      this.turKontrol = true;

      this.turDegeri = "Stok Grup Karlılık";
      this.listeleTop();
    },
    stokKarlilik() {
      this.turKontrol = true;

      this.turDegeri = "Stok Karlılık";
      this.listeleTop();
    },
    cariKarlilik() {
      this.turKontrol = true;

      this.turDegeri = "Cari Karlılık";
      this.listeleTop();
    },
    getNow() {
      const today = new Date();
      const date =
        today.getDate() +
        "." +
        (today.getMonth() + 1) +
        "." +
        today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    getLastTreeMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d.toLocaleDateString();
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
    listeleTop() {
      var vm = this;
      var vs = this.$vs;
      if (vm.turDegeri == "Cari Karlılık")
        vs.loading({
          background: "#640064",
          color: "#fff",
          container: "#button-with-loading-cari",
          scale: 0.45
        });
      else if (vm.turDegeri == "Stok Karlılık")
        vs.loading({
          background: "#640064",
          color: "#fff",
          container: "#button-with-loading-stok",
          scale: 0.45
        });
      else if (vm.turDegeri == "Stok Grup Karlılık")
        vs.loading({
          background: "#640064",
          color: "#fff",
          container: "#button-with-loading-stokgrup",
          scale: 0.45
        });
      else if (vm.turDegeri == "Personel Karlılık")
        vs.loading({
          background: "#640064",
          color: "#fff",
          container: "#button-with-loading-personel",
          scale: 0.45
        });

      var bitis, baslangic;
      if (this.datepickerbaslangic == "") {
        baslangic = vm.getLastTreeMonth();
      } else
        baslangic = moment(String(this.datepickerbaslangic)).format(
          "DD.MM.YYYY"
        );
      if (this.datepickerbitis == "") {
        bitis = vm.getNow();
      } else bitis = moment(String(this.datepickerbitis)).format("DD.MM.YYYY");

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        karlilikDegeri: vm.turDegeri,
        ilkTarih: baslangic,
        sonTarih: bitis,
        aranan: vm.arananDeger
      };
      console.log(args);
      soap.createClient(url, function(err, client) {
        client.INT_Karlilik_Raporu(args, function(err, result) {
          if (result.INT_Karlilik_RaporuResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          try {
            vm.veriler = JSON.parse(result.INT_Karlilik_RaporuResult);
            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);
              console.log(list);

              if (vm.turDegeri == "Cari Karlılık") {
                vs.loading.close("#button-with-loading-cari > .con-vs-loading");
                vm.rowDataCari = list;
              } else if (vm.turDegeri == "Stok Karlılık") {
                vm.rowDataStok = list;
                vs.loading.close("#button-with-loading-stok > .con-vs-loading");
              } else if (vm.turDegeri == "Stok Grup Karlılık") {
                vs.loading.close(
                  "#button-with-loading-stokgrup > .con-vs-loading"
                );
                vm.rowDataStokgrup = list;
              } else if (vm.turDegeri == "Personel Karlılık") {
                vm.rowDataPersonel = list;
                vs.loading.close(
                  "#button-with-loading-personel > .con-vs-loading"
                );
              }
            } else {
              vs.loading.close("#button-with-loading-cari > .con-vs-loading");
              vs.loading.close("#button-with-loading-stok > .con-vs-loading");
              vs.loading.close(
                "#button-with-loading-stokgrup > .con-vs-loading"
              );
              vs.loading.close(
                "#button-with-loading-personel > .con-vs-loading"
              );
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-cari > .con-vs-loading");
            vs.loading.close("#button-with-loading-stok > .con-vs-loading");
            vs.loading.close("#button-with-loading-stokgrup > .con-vs-loading");
            vs.loading.close("#button-with-loading-personel > .con-vs-loading");
          }
        });
      });
    }
  },
  beforeMount() {
    this.columnDefsCari = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "CariKarlilikDetayButon"
      },
      {
        headerName: "Cari No",
        field: "NO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Cari Adı",
        field: "ADI",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Parça Ad",
        field: "ADET",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tutar",
        field: "TUTAR",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params => this.currencyFormatter(params.data.TUTAR, "₺")
      },
      {
        headerName: "Maliyet",
        field: "MALIYET",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params =>
          this.currencyFormatter(params.data.MALIYET, "₺")
      },
      {
        headerName: "Kar",
        field: "KAR",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params => this.currencyFormatter(params.data.KAR, "₺")
      },
      {
        headerName: "Kar %",
        field: "KARORAN",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.columnDefsPersonel = [
      {
        headerName: "Grup Adı",
        field: "ADI",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Adet",
        field: "ADET",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tutar",
        field: "TUTAR",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params => this.currencyFormatter(params.data.TUTAR, "₺")
      },
      {
        headerName: "Maliyet",
        field: "MALIYET",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params =>
          this.currencyFormatter(params.data.MALIYET, "₺")
      },
      {
        headerName: "Kar",
        field: "KAR",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params => this.currencyFormatter(params.data.KAR, "₺")
      },
      {
        headerName: "Kar %",
        field: "KARORAN",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.columnDefsStokgrup = [
      {
        headerName: "Stok Adı",
        field: "ADI",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Parça Adet",
        field: "ADET",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tutar",
        field: "TUTAR",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params => this.currencyFormatter(params.data.TUTAR, "₺")
      },
      {
        headerName: "Maliyet",
        field: "MALIYET",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params =>
          this.currencyFormatter(params.data.MALIYET, "₺")
      },
      {
        headerName: "Kar",
        field: "KAR",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params => this.currencyFormatter(params.data.KAR, "₺")
      },
      {
        headerName: "Kar %",
        field: "KARORAN",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.columnDefsStok = [
      {
        headerName: "Stok No",
        field: "NO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Stok Adı",
        field: "ADI",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Adet",
        field: "ADET",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tutar",
        field: "TUTAR",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params => this.currencyFormatter(params.data.TUTAR, "₺")
      },
      {
        headerName: "Kar",
        field: "KAR",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params => this.currencyFormatter(params.data.KAR, "₺")
      },
      {
        headerName: "Kar %",
        field: "KARORAN",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
  }
};
</script>
